import { render, staticRenderFns } from "./update-collection.vue?vue&type=template&id=2b33ef96"
import script from "./update-collection.js?vue&type=script&lang=js&external"
export * from "./update-collection.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports